import { URL_CONFIG } from "@config/urlConfig";

/**
 * Get default client configuration from environment
 * @returns {Object} Default client with clientId and clientName
 */
export const getDefaultClient = () => {
  return {
    clientId: URL_CONFIG.DEFAULT_CLIENT.CLIENT_ID,
    clientName: URL_CONFIG.DEFAULT_CLIENT.CLIENT_NAME,
  };
};

/**
 * Get client from localStorage or return default
 * @returns {Object} Client object with clientId and clientName
 */
export const getStoredClient = () => {
  const storedClient = localStorage.getItem("selectedClient");
  if (storedClient) {
    try {
      return JSON.parse(storedClient);
    } catch (error) {
      console.error("Error parsing stored client:", error);
      return getDefaultClient();
    }
  }
  return getDefaultClient();
};

/**
 * Save client to localStorage
 * @param {string|number} clientId - Client ID
 * @param {string} clientName - Client name
 */
export const saveClientToStorage = (clientId, clientName) => {
  const clientData = { clientId, clientName };
  localStorage.setItem("selectedClient", JSON.stringify(clientData));
  return clientData;
};

/**
 * Remove client from localStorage
 */
export const removeClientFromStorage = () => {
  localStorage.removeItem("selectedClient");
};

/**
 * Check if client exists in localStorage
 * @returns {boolean}
 */
export const hasStoredClient = () => {
  return localStorage.getItem("selectedClient") !== null;
};
